export default __webpack_public_path__ + "static/media/IconVideo.c98553ac.svg";